<template>
    <div
        ref="container"
        v-html="html"
    />
</template>

<script setup>
    import { onBeforeUnmount } from 'vue'
    import { useRouter } from 'vue-router'

    const { openUrl } = useHelpers()
    const moduleHelpers = useModuleHelpers()
    const router = useRouter()

    const props = defineProps({
        html: String,
    })

    const container = ref(null)

    const listener = (e) => {
        if (!e.target) {
            return
        }

        // NOTE: Closest will return the element itself if it matches
        const el = e.target.closest('a[href]')
        if (!el) {
            return
        }

        // Prevent default browser behaviour
        e.stopPropagation()
        e.preventDefault()

        // Open the link in the in app browser
        const url = el.getAttribute('href')

        // Handle API actions used for deep linking
        const apiActionData = el.getAttribute('data-api-action')
        if (apiActionData) {
            moduleHelpers.handleClick(
                router,
                {
                    link: JSON.parse(apiActionData),
                },
                null,
                false,
            )
            return
        }

        openUrl({ url })
    }

    onMounted(() => {
        container.value.addEventListener('click', listener)
    })

    onBeforeUnmount(() => {
        if (container.value) {
            container.value.removeEventListener('click', listener)
        }
    })
</script>
